module.exports = __webpack_public_path__ + "img/screen_user.f3bff540.png";